import { FC, ReactNode } from 'react'
import { useIntercom } from 'react-use-intercom'

import { Button, Text } from '@/components/componentLibrary'
import { InvalidRouteTemplate } from '@/components/layouts'
import { signOut } from '@/modules/authentication'

/**
 * Shared shell for the dead ends the region routes fall back to: a headline
 * naming what the user is missing, plus a way out. Each page keeps its own
 * monitoring call, since what is worth reporting differs.
 *
 * These render from the region index route, which sits outside every layout, so
 * there is no shelf or nav bar here and no GlobalModal to open profile settings
 * from. That leaves sign-out as the only way off the page, so this offers it
 * directly rather than stranding the user on a screen with no exit.
 */
export const NoAccessTemplate: FC<{ primaryText: ReactNode }> = ({ primaryText }) => {
  const { showNewMessage } = useIntercom()

  return (
    <InvalidRouteTemplate
      primaryTextContent={<Text styleType="title-light">{primaryText}</Text>}
      secondaryTextContent={
        <Text styleType="body">
          If this problem persists, contact your Populus plan administrator.
        </Text>
      }
      actionsContent={
        <>
          <Button
            extraWide
            onClick={() => showNewMessage()}
            small
            text="Contact The Populus Team"
          />
          <Button extraWide onClick={() => signOut()} secondary small text="Sign Out" />
        </>
      }
    />
  )
}
